import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg'
import Button from '@/components/Button'
import DataTable from '@/components/DataTable/index'
import DatePicker from '@/components/DatePicker/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import MultiSelectCheckbox from '@/components/MultiSelectCheckbox/index'
import Toast2 from '@/components/Toast2'
import useConfig from '@/hooks/use-config'
import useDataPage from '@/hooks/use-data-page/index'
import useFilter from '@/hooks/use-filter'
import useMessages from '@/hooks/use-messages'
import usePage from '@/hooks/use-page'
import useModal from '@/hooks/use-modal/index'
import usePitstopConfig from '@/hooks/use-pitstop-config'
import { useNavigate } from '@/lib/router-dom'
import "@/translations/i18n"
import rem from '@/utils/rem.js'
import classname from 'classnames'
import { produce } from 'immer'
import { orderBy } from 'lodash'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from "react-i18next"
import { useSelector } from 'react-redux'
import { DATA_TABLE_PARENT } from '@/constants/index.js'
import Search from '@/componentsDS/Search/index';
import { features as featureConstant } from "@/utils/feature-verifier";
import { ReactComponent as IconConfigure } from '@/assets/svgs/icon-configure.svg';

import Breadcrumbs from '@/componentsDS/Breadcrumbs/index.jsx'
import SearchInput from './components/Search/index'
import MultiSelectFilter from './components/MultiSelectFilter/index'
import { useFeature } from '@/hooks/use-feature/index'
import { useBuildex } from "@/hooks/use-buildex";

const Page = () => {

	/*=================================================1
		General
	/================================================*/
	const isBuildex = useBuildex()
	const isSupersetDashboard = useFeature(featureConstant.DASHBOARD);
	const isHomePage = !(isBuildex && isSupersetDashboard)

	const { t } = useTranslation();
	const [pageTitle, setPageTitle] = useState(t("sharedData"))

	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: `/`,
				isHomePage: isHomePage
			},
			{
				label: 'Shared Data',
				link: `/shared-data`
			}
		]
	 })
	const { goTo } = useNavigate();
	const [configInit, setConfigInit] = useState(false)

	const pageLimit = 10

	const [coords, setCoords] = useState({});

	const { user, profile } = useSelector(state => state.auth)

	const [refIdSearch, setRefIdSearch] = useState('')

	/*=================================================
		Error Modal
	/================================================*/
	const [error, setError] = useState()
	function handleError() {
		setError()
	}

	/*=================================================
		API
	/================================================*/

	const { config, isProvider, isAbleToPassiveProvide } = useConfig()
	const { items: messages, meta: messagesMeta, postFetch, error: erroMessages } = useMessages()
	const { filter, fetch: fetchFilter } = useFilter()
	const { fetch } = usePitstopConfig()
	const [simulate, setSimulate] = useState(false)


	const { error: dataExpiryError } = useSelector(state => state.dataExpiry)

	function updateSimulateState(_config) {
		let _simulate = false
		if (_config && (_config.isSandbox || !_config.otherUrl)) {
			_simulate = true
		}
		else {
			_simulate = false
		}
		setSimulate(_simulate)
	}

	useEffect(() => {
		async function getData() {
			fetchFilter({ messageType: 'PUSH,STORE,PROVIDE' })
		}
		getData()
	}, [])

	useEffect(() => {
		setConfigInit(true)
	}, [])

	useEffect(() => {
		updateSimulateState(config)
		fetchMessageHandler()
	}, [config])

	useEffect(() => {
		fetch().then(val => {
			if (val === null)
				showModal();
		}).catch(value => {
			setError(value?.error?.message)
		})
	}, [])

	useEffect(() => {
		if (dataExpiryError) {
			setError(dataExpiryError)
		} else {
			setError(erroMessages)
		}
	}, [dataExpiryError, erroMessages])

	function fetchMessageHandler() {
		if (currentPage) {
			postFetch({
				dataElementId: convertArrayToString(dataElementsOptions) ?? null,
				page: currentPage,
				orgId: convertArrayToString(participantsOptions) ?? null,
				limit: pageLimit,
				messageStatus: convertArrayToString(statusOptions) ?? null,
				messageType: (convertArrayToString(typeOptions) !== null ? convertArrayToString(typeOptions) : 'PUSH,STORE,PROVIDE'),
				dateFrom: (startDate !== null ? moment(startDate).format('yyyy-MM-DD HH:mm') : null),
				dateTo: (endDate !== null ? moment(endDate).format('yyyy-MM-DD HH:mm') : null),
				sortBy: sortConfig.key,
				order: (sortConfig.direction === true ? "ASC" : "DESC"),
				referenceId: refIdSearch
			})
		}
	}

	/*=================================================
		Modal
	/================================================*/

	const { visible: isModalVisible, show: showModal, hide: hideModal } = useModal()
	const { visible: visibleDownloadData, hide: hideDownloadData, show: showDownloadData } = useModal()

	/*=================================================
		Options
	/================================================*/

	const { fileSize, checkFileSize } = useDataPage()
	const { dataElementsOptions, setDataElementsOptions } = useDataPage()
	const { participantsOptions, setParticipantsOptions, statusOptions, setStatusOptions } = useDataPage()

	const [typeOptions, setTypeOptions] = useState([
		{ id: 'STORE', label: t("store"), $selected: false },
		{ id: 'PUSH', label: t("push"), $selected: false },
		{ id: 'PROVIDE', label: t("provide"), $selected: false },
	])


	useEffect(() => {
		if (!filter?.dataElements || filter?.dataElements.length === 0) {
			return
		}

		const sharedUpdatedOptions = filter?.dataElements.map(item => ({ id: item.dataElementId, label: item.elementName, $selected: false }))
		const sharedSortedOptions = orderBy(sharedUpdatedOptions, [option => option.label.toLowerCase(), ['asc']])

		setDataElementsOptions(sharedSortedOptions)

	}, [filter])

	useEffect(() => {
		if (!filter?.orgs || filter?.orgs.length === 0) {
			return
		}

		const sharedUpdatedOptions = filter?.orgs.map(item => ({ id: item.orgId, label: item.name, $selected: false }))

		sharedUpdatedOptions.push({
			id: user?.organizationId,
			label: 'My Pitstop',
			$selected: false
		})
		const sharedSortedOptions = orderBy(sharedUpdatedOptions, [option => option.label.toLowerCase(), ['asc']])

		setParticipantsOptions(sharedSortedOptions)

	}, [filter])

	const [startDate, setStartDate] = useState(null)
	const [endDate, setEndDate] = useState(null)
	const [expiryDays, setExpiryDays] = useState(0);

	useEffect(() => {
		return setEndDate(null);
	}, [startDate]);

	/*=================================================
		Sort
	/================================================*/

	const { sortConfig } = useDataPage()

	/*=================================================
		Paginate
	/================================================*/

	const { currentPage, setCurrentPage, goToNext, goToPrev, handleCurrentInput, updatedData, changeAllListCheckboxes, changeListCheckboxes } = useDataPage()

	useEffect(() => {
		fetchMessageHandler()
	}, [currentPage, dataElementsOptions, participantsOptions, statusOptions, typeOptions, startDate, endDate, sortConfig, refIdSearch])

	useEffect(() => {
		if (currentPage > messagesMeta?.totalPages) {
			setCurrentPage(messagesMeta?.totalPages || 1)
		}
	}, [messages])

	/*=================================================
		Routes
	/================================================*/

	const { goToShare, goToStimulateProvide } = useDataPage()

	/*=================================================
		Data Table
	/================================================*/

	const SharedDataTable = ({ itemData, type }) => {
		const args = {
			itemData: itemData,
			type: type,
			parentComponentName: DATA_TABLE_PARENT.SHARED_DATA,
			currentPage: currentPage,
			goToNextPage: goToNext,
			goToPrevPage: goToPrev,
			meta: messagesMeta,
			handleCurrentInput: handleCurrentInput,
			changeAllListCheckboxes: changeAllListCheckboxes,
			changeListCheckboxes: changeListCheckboxes,
			showModal: showDownloadData,
			checkFileSize: checkFileSize
		}

		return DataTable(args);
	}

	/*=================================================
		Function
	/================================================*/

	const { convertArrayToString, downloadFile, setFileType, setIncludeAttachments, fileType, includeAttachments, isAnySelected } = useDataPage()
	const getOverviewClass = classname({
		"overview": true,
		"overview--empty": !isProvider
	})

	function resetSharedDataFilter() {
		function setFalse(array) {
			const updatedItems = produce(array, draft => {
				draft.forEach(
					item => item.$selected = false
				)
			})
			return updatedItems
		}

		setDataElementsOptions(setFalse(dataElementsOptions))
		setParticipantsOptions(setFalse(participantsOptions))
		setStatusOptions(setFalse(statusOptions))
		setTypeOptions(setFalse(typeOptions))
		setStartDate(null)
		setEndDate(null)
		setRefIdSearch("")
	}

	const isFilterActive = useMemo(() => {
		return !!(
			isAnySelected(dataElementsOptions) ||
			isAnySelected(participantsOptions) ||
			isAnySelected(statusOptions) ||
			isAnySelected(typeOptions) ||
			startDate ||
			endDate
		  )
	  }, [dataElementsOptions, participantsOptions, statusOptions, startDate, endDate, typeOptions]);

	const sharedFilterConfig = [
		{
		  id: "dataElement",
		  title: "Data Element",
		  props: {
			items: dataElementsOptions,
			onChangeFunc: setDataElementsOptions,
			disable: !isProvider || (messages.length === 0 && (isBuildex ? !isFilterActive : true)),
		  },
		},
		{
		  id: "Destination",
		  title: "Destination",
		  props: {
			items: participantsOptions,
			onChangeFunc: setParticipantsOptions,
			disable: !isProvider || (messages.length === 0 && (isBuildex ? !isFilterActive : true)),
		  },
		},
		{
		  id: "type",
		  title: "Type",
		  props: {
			items: typeOptions,
			onChangeFunc: setTypeOptions,
			disable: !isProvider || (messages.length === 0 && (isBuildex ? !isFilterActive : true)),
		  },
		}
	  ];

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">
						{pageTitle}
					</div>
				</div>
				<div className="title-header__right">
					<div className="overview__filter overview__button_wrap">
						{!isBuildex && simulate && (
							<Button dotted round full text={t("simulateProvide")} id="simulate-provider-button-id" submit={goToStimulateProvide} disabled={!(isAbleToPassiveProvide)} />
						)}

						<Button
							round
							full
							text={t("shareData")}
							id="share-data-button-id"
							submit={goToShare}
							disabled={
								!isProvider ||
								(
									!(
										profile?.organization?.makerChecker === false ||
										(profile?.organization?.makerChecker === true && profile?.makerCheckerRole === 'MAKER')
									)
								)
							}
						/>
					</div>
				</div>
			</div>

			<hr />

			<div className={getOverviewClass}>
			<MultiSelectFilter
			    filterConfig={sharedFilterConfig}
				statusOptions={statusOptions}
				setStatusOptions={setStatusOptions}
				startDate={startDate}
				setStartDate={setStartDate}
				endDate={endDate}
				setEndDate={setEndDate}
				resetFilter={resetSharedDataFilter}
				disableFilters={!isProvider || (messages.length === 0 && (isBuildex ? !isFilterActive : true))}
				/>
               <SearchInput
                value={refIdSearch}
                placeholder="Search by Reference ID"
                onChange={(e) => setRefIdSearch(e?.target.value)}
                onCancel={() => setRefIdSearch('')}
              />

				<div className="overview__content overview__content--shared-data">
					{SharedDataTable({ itemData: updatedData.length > 0 ? updatedData : messages })}
				</div>
			</div>

			<Modal visible={isModalVisible} variant='medium'  close={hideModal}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon'}>
											<IconConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Add API Configuration
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div style={{ fontSize: rem(14), textAlign: 'center' }}>Do you want to configure your API ?</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button ghost text="No"
								submit={() => {
									hideModal()
								}} />
							<span style={{ width: rem(10), display: 'inline-block' }}></span>

							<Button text="Yes"
								submit={() => {
									goTo('/configuration/api-configuration')
								}} />
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={visibleDownloadData} variant='medium' close={hideDownloadData}>
				<CardConfigure>
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon'}>
											<IconConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
										Download Transaction
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="download-transaction__rows">
								<div className="download-transaction__row">
									You are about to export {updatedData.filter(message => message.$selected === true).length} transaction ({fileSize}MB)
								</div>
								<div className="download-transaction__row">
									<div className="download-transaction__row__left">
										Export data as
									</div>
									<div className="download-transaction__row__right">
										<div className="download-transaction__row__right__radio">
											<input type="radio" value="json" name="fileType" id="json"
												checked={fileType == "json"}
												onChange={(e) => setFileType(e.target.value)}
											/> <label htmlFor="json">JSON</label>
										</div>
										<div className="download-transaction__row__right__radio">
											<input type="radio" value="csv" name="fileType" id="csv"
												checked={fileType == "csv"}
												onChange={(e) => setFileType(e.target.value)}
											/> <label htmlFor="csv">CSV</label>
										</div>
									</div>
								</div>
								<div className="download-transaction__row">
									<div className="download-transaction__row__left">
										Include attachments
									</div>
									<div className="download-transaction__row__right">
										<div className="download-transaction__row__right__radio">
											<input type="radio" value={true} name="includeAttachment" id="yes"
												checked={includeAttachments == JSON.parse("true")}
												onChange={() => setIncludeAttachments(true)}
												disabled={fileSize > 250}
											/> <label htmlFor="yes">Yes</label>
											{
												(fileSize > 250) && (
													<span className="download-transaction__row__right__radio__message">
														Download size is too large
													</span>
												)
											}
										</div>
										<div className="download-transaction__row__right__radio">
											<input type="radio" value={false} name="includeAttachment" id="no"
												checked={includeAttachments == JSON.parse("false")}
												onChange={() => setIncludeAttachments(false)}
											/> <label htmlFor="no">No</label>
											<span className="download-transaction__row__right__radio__message">
												&nbsp; (download data only)
											</span>
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button text="Download"
								disabled={fileType ? false : true}
								submit={() => {
									downloadFile(updatedData)
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
			<Toast2 show={error} errorMessage={error} close={() => { handleError() }} />
		</>
	)
}

export default Page
